import { TaxPayerType } from './types'

interface TaxPayerProps {
  tax_payer: TaxPayerType
}

export default function TaxPayer({ tax_payer }: TaxPayerProps) {
  return (
    <div>
      <p className="my-5">
        <strong className="block font-medium mb-1">Name:</strong>
        {tax_payer.name?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Fullname:</strong>
        {tax_payer.fullName?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Category:</strong>
        {tax_payer.category_id?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Area:</strong>
        {tax_payer.area_id?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Nif:</strong>
        {tax_payer.nif?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Rccm:</strong>
        {tax_payer.rccm?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Status:</strong>
        {tax_payer.status?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Community:</strong>
        {tax_payer.community_id?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Address:</strong>
        {tax_payer.address?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Latitude:</strong>
        {tax_payer.latitude?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Longitude:</strong>
        {tax_payer.longitude?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Email:</strong>
        {tax_payer.email?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Phone:</strong>
        {tax_payer.phone?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Code:</strong>
        {tax_payer.code?.toString()}
      </p>
    </div>
  )
}
